<template>
  <div class="content-form pa-4">
    <!-- 読み取り専用: 識別情報 -->
    <div class="section-label">識別情報</div>
    <v-card outlined class="mb-6 pa-4 readonly-section">
      <v-row dense>
        <v-col cols="3">
          <div class="info-label">コード</div>
          <div class="info-value">{{ code || '---' }}</div>
        </v-col>
        <v-col cols="3">
          <div class="info-label">教科</div>
          <div class="info-value">{{ subjectName || '---' }}</div>
        </v-col>
        <v-col cols="3">
          <div class="info-label">学年</div>
          <div class="info-value">{{ gradeName || '---' }}</div>
        </v-col>
        <v-col cols="3">
          <div class="info-label">設問数</div>
          <div class="info-value">{{ questionCnt != null ? questionCnt : '---' }}</div>
        </v-col>
      </v-row>
    </v-card>

    <!-- 編集: 基本情報 -->
    <div class="section-label">基本情報</div>
    <v-card outlined class="mb-6 pa-4">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="name"
            label="単元名"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="shortCode"
            label="問題管理番号"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="difficultyId"
            :items="difficulties"
            item-text="name"
            item-value="id"
            label="難易度"
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="contentType"
            :items="contentTypes"
            item-text="text"
            item-value="value"
            label="種別"
            outlined
            dense
          ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <!-- 編集: 詳細情報 -->
    <div class="section-label">詳細情報</div>
    <v-card outlined class="mb-6 pa-4">
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="fiscalYear"
            label="年度"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="shinkenkyuNumber"
            label="新研究番号"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="essayQuestionCnt"
            label="記述設問数"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="listeningTime"
            label="リスニング時間"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="questionDetail"
            label="問題内容"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <v-checkbox
            v-model="sample"
            label="前学年抽出フラグ"
            hide-details
            class="mt-0"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card>

    <div class="d-flex justify-end">
      <v-btn color="secondary" dark @click.stop="submit">
        <v-icon left small>mdi-content-save</v-icon>
        保存
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentTypes: [
        { text: '無料', value: 'free' },
        { text: '有料', value: 'paid' },
      ],
    }
  },
  computed: {
    code() { return this.$store.state.content.code },
    subjectName() { return this.$store.state.content.subjectName },
    gradeName() { return this.$store.state.content.gradeName },
    questionCnt() { return this.$store.state.content.questionCnt },
    name: {
      get() { return this.$store.state.content.name },
      set(value) { this.$store.commit('content/setName', { name: value }) }
    },
    shortCode: {
      get() { return this.$store.state.content.shortCode },
      set(value) { this.$store.commit('content/setShortCode', { shortCode: value }) }
    },
    difficultyId: {
      get() { return this.$store.state.content.difficultyId },
      set(value) { this.$store.commit('content/setDifficultyId', { difficultyId: value }) }
    },
    contentType: {
      get() { return this.$store.state.content.contentType },
      set(value) { this.$store.commit('content/setContentType', { contentType: value }) }
    },
    fiscalYear: {
      get() { return this.$store.state.content.fiscalYear },
      set(value) { this.$store.commit('content/setFiscalYear', { fiscalYear: value }) }
    },
    shinkenkyuNumber: {
      get() { return this.$store.state.content.shinkenkyuNumber },
      set(value) { this.$store.commit('content/setShinkenkyuNumber', { shinkenkyuNumber: value }) }
    },
    essayQuestionCnt: {
      get() { return this.$store.state.content.essayQuestionCnt },
      set(value) { this.$store.commit('content/setEssayQuestionCnt', { essayQuestionCnt: value }) }
    },
    questionDetail: {
      get() { return this.$store.state.content.questionDetail },
      set(value) { this.$store.commit('content/setQuestionDetail', { questionDetail: value }) }
    },
    sample: {
      get() { return this.$store.state.content.sample },
      set(value) { this.$store.commit('content/setSample', { sample: value }) }
    },
    listeningTime: {
      get() { return this.$store.state.content.listeningTime },
      set(value) { this.$store.commit('content/setListeningTime', { listeningTime: value }) }
    },
    difficulties() {
      return this.$store.state.master.allDifficulties || []
    },
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('content/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
  },
}
</script>

<style lang="stylus" scoped>
.content-form
  max-width 960px

.section-label
  font-size 14px
  font-weight bold
  color #555
  margin-bottom 8px
  padding-left 4px

.readonly-section
  background-color #fafafa

.info-label
  font-size 12px
  color #888
  margin-bottom 2px

.info-value
  font-size 16px
  font-weight 500
  color #333
</style>
